const module = { name: 'news/awards/app', exports: {} }; const exports = module.exports;



import { Fandango_debugLog as debugLog } from 'require-core';



// @ts-ignore
const checkDependencies = (moduleName, fn) => (fn?.log ?? console.debug)(`Initializing...${moduleName}`);


import { default as $ } from 'swug-fdRequire-call:jQuery';

function markWinners() {
    const $nomineeLists = $('.js-nominee');
    $.each($nomineeLists, function () {
        const $nominee = $(this);
        if ($nominee.hasClass('nominee__winner')) {
            $nominee.closest('.js-nominees__list').addClass('found-winner');
        }
    });
}
function run() {
    checkDependencies(module.name, debugLog);
    markWinners();
}
document.addEventListener('DOMContentLoaded', run);
export default module.exports;